import {
  RISK_ELEVATED_LIMIT,
  RISK_EXTREME_LIMIT,
  RISK_HIGH_LIMIT,
  RISK_MODERATE_LIMIT,
  RISK_SIGNIFICANT_LIMIT,
  RISK_VERY_HIGH_LIMIT,
} from '@/constants';
import { RiskLevel } from '@/types';

export const toPascalCase = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getRiskLabel = (riskScore: number): RiskLevel => {
  if (riskScore < RISK_MODERATE_LIMIT) return 'Low';
  if (riskScore >= RISK_MODERATE_LIMIT && riskScore < RISK_ELEVATED_LIMIT)
    return 'Moderate';
  if (riskScore >= RISK_ELEVATED_LIMIT && riskScore < RISK_SIGNIFICANT_LIMIT)
    return 'Elevated';
  if (riskScore >= RISK_SIGNIFICANT_LIMIT && riskScore < RISK_HIGH_LIMIT)
    return 'Significant';
  if (riskScore >= RISK_HIGH_LIMIT && riskScore < RISK_VERY_HIGH_LIMIT)
    return 'High';
  if (riskScore >= RISK_VERY_HIGH_LIMIT && riskScore < RISK_EXTREME_LIMIT)
    return 'Very high';
  return 'Extreme';
};

export const getFirstName = (name: string): string => {
  const parts = name.split(', ');

  return parts?.[1].replace(' (ext)', '') ?? '';
};
